import { savedOrderDetailsProductListStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(savedOrderDetailsProductListStyles, {
    wrapper: {
        css: css`
            border-top: 1px solid ${getColor("common.border")};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [20, null, 40, null, null], properties: ["margin-top"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
});
